export function getPatientAction(record) {
  const hasLinkedPatient = Number(record?.patientId) > 0;
  const isAccepted = String(record?.status || "").toLowerCase() === "accepted";

  if (isAccepted && !hasLinkedPatient) return "create";
  if (hasLinkedPatient) return "edit";
  return null;
}
